<div class="relative flex flex-col gap-2 items-start h-full">
    <div *ngIf="label" class="typography-body-s-regular">{{ label }}</div>
    <div class="flex {{divClass}} display-contents" [ngClass]="{'w-full': block}">
        <input
            #input
            class="min-h-[40px] box-border px-4 py-2 border border-border-secondary typography-body-m-regular appearance-none {{ class }}"
            [ngClass]="{
                'flex-1': block,
                'disabled-input': disabled,
                'border-border-danger': required && !isValueValid(value) && dirty,
                'border-border-secondary': !required || isValueValid(value) || !dirty,
                'number-input': isNumberType()
            }"

            [type]="type"
            [placeholder]="placeholder"
            [value]="value"
            [attr.list]="dataListId"
            [min]="min"
            [max]="max"
            [attr.maxlength]="maxLength ? maxLength : null"
            [attr.step]="isNumberType() && maxDecimals > 0 ? '0.' + '0'.repeat(maxDecimals-1) + '1' : '1'"
            (focus)="onFocus($event)"
            (blur)="onBlur($event)"
            (change)="onChange($event)"
            (keyup)="onKeyDown($event)"
            (focusout)="onFocusOut($event)"
            (input)="onInput($event)"
        />
        <!-- Comentado poque se visualiza descolocado -->
        <div *ngIf="isNumberType() && type === 'number' && showArrows" class="number-controls absolute right-0 h-full flex flex-col">
        <!--     <button 
                type="button" 
                class="h-1/2 px-2 text-xs flex items-center justify-center" 
                [disabled]="disabled || (max !== null && parseNumberValue(input.value) >= max)"
                (click)="incrementValue(input)"
            >
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 0L9.33013 6H0.669873L5 0Z" fill="currentColor"/>
                </svg>
            </button>
            <button 
                type="button" 
                class="h-1/2 px-2 text-xs flex items-center justify-center" 
                [disabled]="disabled || parseNumberValue(input.value) <= min"
                (click)="decrementValue(input)"
            >
                <svg width="10" height="6" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M5 6L0.669872 0L9.33013 0L5 6Z" fill="currentColor"/>
                </svg>
            </button> -->
        </div>
    </div>

    <datalist [id]="dataListId">
        <option *ngFor="let value of suggestions" [value]="value">
    </datalist>
</div>
